module.exports = __webpack_public_path__ + "static/forecast/windstock/light-e3afe3e2b8581eac4904ee2a60702554.svg";